import React, { PropTypes } from "react";
import B from "bem-cn";
import { Button } from "react-toolbox/lib/button";
import getStaticContent from "../../utils/getStaticContent";

import "./slider.scss";

const cl = B("Slider");
const SLIDE_BASE_CLASS = "Slider__slideItem";

export default class Slider extends React.PureComponent {
  static propTypes = {
    init: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired,
    readerContentIdxList: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    currentPageName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    const defaultActive = this.props.init;

    this.placeholdersColors = [];
    this.animationInProgress = false;
    this.staticContent = getStaticContent("slider", props.currentPageName);

    this.state = {
      slider: this.getActiveState(defaultActive),
      yourDomain: "www.your-website.com",
    };

    this.slidePrev = this.slidePrev.bind(this);
    this.slideNext = this.slideNext.bind(this);
    this.setRef = (ref) => {
      this._selfRef = ref;
    };
  }

  componentDidMount() {
    // Get yourDomain from "url" param
    if (location.search) {
      const params = location.search
        .split("?")[1]
        .split("&")
        .reduce((params, param) => {
          const partsParam = param.split("=");
          params[partsParam[0]] = decodeURIComponent(partsParam[1]);
          return params;
        }, {});
      if (params.url) {
        this.setState({
          yourDomain: params.url,
        });
      }
    }
  }

  getActiveState({ rowIdx, itemIdx }) {
    const prevSlide = this.getPrevSlide(rowIdx, itemIdx);
    const nextSlide = this.getNextSlide(rowIdx, itemIdx);

    return {
      current: {
        rowIdx,
        itemIdx,
        content: this.getPlaceholdersColors(rowIdx, itemIdx),
      },
      prev: prevSlide,
      before_prev: this.getPrevSlide(prevSlide.rowIdx, prevSlide.itemIdx),
      next: nextSlide,
      after_next: this.getNextSlide(nextSlide.rowIdx, nextSlide.itemIdx),
    };
  }

  setActiveSlide(obj) {
    this.setState({
      slider: this.getActiveState(obj),
    });
  }

  getNumberIconByRowItem = (rowIdx, itemIdx) => {
    const { items } = this.props;
    let numberIcon = 0;
    let numRow = 0;
    do {
      if (numRow < rowIdx) {
        numberIcon += items[numRow];
      } else {
        numberIcon += itemIdx;
      }
    } while (numRow++ < rowIdx);
    return numberIcon;
  };

  getPlaceholdersColors(rowIdx, itemIdx) {
    const { readerContentIdxList } = this.props;

    if (typeof this.placeholdersColors[rowIdx] === "undefined") {
      this.placeholdersColors[rowIdx] = [];
    }
    if (typeof this.placeholdersColors[rowIdx][itemIdx] === "undefined") {
      this.placeholdersColors[rowIdx][itemIdx] = readerContentIdxList[rowIdx][
        itemIdx
      ].map((content) =>
        this.getNumberIconByRowItem(content.rowIdx, content.itemIdx)
      );
    }

    return this.placeholdersColors[rowIdx][itemIdx];
  }

  getNumberAvatar(slide) {
    return this.getNumberIconByRowItem(slide.rowIdx, slide.itemIdx);
  }

  getSlidePlate = (itemType, itemIndex) => (
    <div
      key={`content-${itemIndex}`}
      className={cl("slidePlaceholder", { item: itemIndex + 1 })}
    >
      <div
        className={cl("slidePlaceholderFill", {
          item: String(itemType),
        })}
      />
    </div>
  );

  getSlide(slide, type) {
    const numberAvatar = this.getNumberAvatar(slide);
    return (
      <div className={cl("slideItem", { [type]: true })}>
        <div className={cl("slideContent")}>
          <div className={cl("slideHeader")}>
            <div>{this.staticContent.title}</div>
            <div
              className={cl("slideHeaderSeparator", {
                item: String(numberAvatar),
              })}
            />
            <div>{this.staticContent.title}</div>
          </div>
          <div className={cl("slideContentWrapper")}>
            {slide.content
              .slice(0, 2)
              .map((itemType, itemIndex) =>
                this.getSlidePlate(itemType, itemIndex)
              )}
            <div className={cl("slidePlaceholderWrapper_345")}>
              {this.getSlidePlate(slide.content[2], 2)}
              <div className={cl("slidePlaceholderWrapper_45")}>
                {this.getSlidePlate(slide.content[3], 3)}
                {this.getSlidePlate(slide.content[4], 4)}
              </div>
            </div>
            {new Array(4).fill(null).map((val, itemIndex) => (
              <div
                key={`empty-content-${itemIndex}`}
                className={cl("slidePlaceholder", {
                  item: slide.content.length + itemIndex + 1,
                })}
              >
                <div className={cl("slidePlaceholderFill")} />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  getNextSlide(rowIdx, itemIdx) {
    itemIdx += 1;
    if (itemIdx > this.props.items[rowIdx] - 1) {
      itemIdx = 0;
      rowIdx += 1;
    }
    if (typeof this.props.items[rowIdx] === "undefined") {
      rowIdx = 0;
    }

    return {
      rowIdx,
      itemIdx,
      content: this.getPlaceholdersColors(rowIdx, itemIdx),
    };
  }

  getPrevSlide(rowIdx, itemIdx) {
    const { items } = this.props;
    itemIdx -= 1;
    if (itemIdx < 0) {
      rowIdx = rowIdx > 0 ? rowIdx - 1 : items.length - 1;

      itemIdx = items[rowIdx] - 1;
    }

    return {
      rowIdx,
      itemIdx,
      content: this.getPlaceholdersColors(rowIdx, itemIdx),
    };
  }

  getSlideNodes(root) {
    const list = ["before_prev", "prev", "current", "next", "after_next"];
    return list.reduce((acc, item) => {
      acc[item] = root.querySelector(`.${SLIDE_BASE_CLASS}_${item}`);
      return acc;
    }, {});
  }

  changeSlideClasses(el, from, to) {
    el.classList.remove(`${SLIDE_BASE_CLASS}_${from}`);
    el.classList.add(`${SLIDE_BASE_CLASS}_${to}`);
  }

  glitchSliderTransition(sliderElement) {
    const items = [...sliderElement.querySelectorAll(`.${SLIDE_BASE_CLASS}`)];
    const placeholdersList = [];
    const subSelectors = [
      ".Slider__slidePlaceholderFill",
      ".Slider__slidePlaceholder",
      ".Slider__slideHeader",
    ];
    items.forEach((item, itemIndex) => {
      item.style.transition = "none";
      placeholdersList[itemIndex] = [
        ...item.querySelectorAll(subSelectors.join(",")),
      ];
      placeholdersList[itemIndex].forEach((placeholder) => {
        placeholder.style.transition = "none";
      });
    });
    setTimeout(() => {
      items.forEach((item, itemIndex) => {
        item.style.transition = null;

        placeholdersList[itemIndex].forEach((placeholder) => {
          placeholder.style.transition = null;
        });
      });
    }, 50);
  }

  slidePrev(e) {
    if (!this.animationInProgress) {
      const { slider } = this.state;
      const sliderElement = this._selfRef;
      const slideElements = this.getSlideNodes(sliderElement);
      slideElements.after_next.style["z-index"] = 0;
      this.changeSlideClasses(slideElements.next, "next", "after_next");
      this.changeSlideClasses(slideElements.current, "current", "next");
      this.changeSlideClasses(slideElements.prev, "prev", "current");
      this.changeSlideClasses(slideElements.before_prev, "before_prev", "prev");
      this.animationInProgress = true;

      this.tm = setTimeout(() => {
        this.glitchSliderTransition(sliderElement);
        this.animationInProgress = false;
        this.setState({
          slider: {
            ...slider,
            before_prev: this.getPrevSlide(
              slider.before_prev.rowIdx,
              slider.before_prev.itemIdx
            ),
            prev: slider.before_prev,
            current: slider.prev,
            next: slider.current,
            after_next: slider.next,
          },
        });
      }, 410);

      this.props.onChange(e, slider.prev.rowIdx, slider.prev.itemIdx, "prev");
    }
  }
  slideNext(e) {
    if (!this.animationInProgress) {
      const { slider } = this.state;
      const sliderElement = this._selfRef;
      const slideElements = this.getSlideNodes(sliderElement);
      slideElements.before_prev.style["z-index"] = 0;
      this.changeSlideClasses(slideElements.prev, "prev", "before_prev");
      this.changeSlideClasses(slideElements.current, "current", "prev");
      this.changeSlideClasses(slideElements.next, "next", "current");
      this.changeSlideClasses(slideElements.after_next, "after_next", "next");
      this.animationInProgress = true;

      this.tm = setTimeout(() => {
        this.glitchSliderTransition(sliderElement);
        this.animationInProgress = false;
        this.setState({
          slider: {
            ...slider,
            before_prev: slider.prev,
            prev: slider.current,
            current: slider.next,
            next: slider.after_next,
            after_next: this.getNextSlide(
              slider.after_next.rowIdx,
              slider.after_next.itemIdx
            ),
          },
        });
      }, 410);

      this.props.onChange(e, slider.next.rowIdx, slider.next.itemIdx, "next");
    }
  }

  render() {
    const { yourDomain } = this.state;

    return (
      <div className={cl} ref={this.setRef}>
        <div className={cl("current-item")}>
          <div className={cl("current-item")("container")}>
            <div className={cl("current-item", "address-bar")} />
            <div className={cl("current-item", "text")}>{yourDomain}</div>
          </div>
        </div>
        <Button
          theme={{
            button: cl("control", { left: true }).mix("hidden-xs hidden-sm"),
          }}
          onClick={this.slidePrev}
          raised
          primary
        />
        <Button
          theme={{
            button: cl("control", { right: true }).mix("hidden-xs hidden-sm"),
          }}
          onClick={this.slideNext}
          raised
          primary
        />
        <div className={cl("big-arrow-bottom")} />

        <div className={cl("slides-container")}>
          {this.getSlide(this.state.slider.before_prev, "before_prev")}
          {this.getSlide(this.state.slider.prev, "prev")}
          {this.getSlide(this.state.slider.current, "current")}
          {this.getSlide(this.state.slider.next, "next")}
          {this.getSlide(this.state.slider.after_next, "after_next")}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/slider/slider.jsx